import React from 'react';
import { Box, CircularProgress, SxProps } from '@mui/material';

interface ILoadingProps {
  marginTop?: number;
  textAlign?: 'center' | 'left' | 'right';
  size?: number;
  sx?: SxProps;
}

const Loading = (props: ILoadingProps) => {
  const { marginTop = 2, size = 24, textAlign = 'center' } = props;
  return (
    <Box textAlign={textAlign} marginTop={marginTop}>
      <CircularProgress size={size} />
    </Box>
  );
};

export default Loading;
